import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ROBOTS_CONTENT } from "@/lib/seo/robotsPolicy";

/**
 * Lägger <meta name="robots" content="noindex, follow"> när URL:en innehåller
 * filter/sort/sid-params. Canonical pekar fortfarande på basversionen, så
 * Google konsoliderar signalerna men slipper indexera 1000-tals filterkombos.
 *
 * Användning: mounta på sidor som tillåter URL-baserad filtrering
 * (t.ex. RidingGearPage, OutletPage med ?storlek/?varumarke).
 */
const FILTER_PARAMS = new Set([
  "sort", "sort_by", "order", "orderby",
  "page", "per_page", "view",
  "brand", "brands", "varumarke", "varumarken",
  "type", "types", "kategori",
  "color", "colors", "size", "sizes", "storlek", "storlekar",
  "price", "min_price", "max_price", "minprice", "maxprice",
  "rating", "instock", "in_stock",
  "tag", "tags", "smak", "alder",
  "filter", "filters",
]);

function setRobots(content: string) {
  let meta = document.querySelector<HTMLMetaElement>('meta[name="robots"]');
  if (!meta) {
    meta = document.createElement("meta");
    meta.name = "robots";
    document.head.appendChild(meta);
  }
  if (meta.content !== content) meta.content = content;
}

export default function FilteredViewNoindex() {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const hasFilter = Array.from(params.keys()).some(k => FILTER_PARAMS.has(k.toLowerCase()));
    if (hasFilter) {
      setRobots(ROBOTS_CONTENT["noindex-follow"]);
    } else {
      // Återställ till default för publika sidor.
      setRobots(`${ROBOTS_CONTENT["index"]}, max-image-preview:large, max-snippet:-1, max-video-preview:-1`);
    }
  }, [location.search]);

  return null;
}
